export default __webpack_public_path__ + "static/dailypay-c7d685f629066243572d8b39fe864a69.png";